<div class="container" *ngIf="patient">

    <!-- CABEÇALHO FORMULÁRIO ******************************************** -->
    <mc-patient-header
        [patient]="patient"
        [schedulingTypeName]="scheduling?.type?.name"
        [appointmentTypeName]="scheduling?.appointment_type?.name">
    </mc-patient-header>

    <!-- LISTA ATENDIMENTOS   ******************************************** -->
    <div class="mb-1" *ngFor="let appointment of appointments">

      <div id="accordion{{appointment.id}}">
        <div class="card">
          <div class="card-header">
            <strong>{{appointment.date | date:'dd/LL/yyyy'}}</strong>
            <button class="btn btn-link float-right pt-0 pb-0 collapsed"
              type="button"
              data-toggle="collapse"
              attr.data-target="#collapse{{appointment.id}}"
              aria-expanded="true" attr.aria-controls="collapse{{appointment.id}}">
              <fa-icon [icon]="eyeIcon"></fa-icon>
            </button>
          </div>
          <div id="collapse{{appointment.id}}" class="collapse" attr.data-parent="#accordion{{appointment.id}}">
            <div class="card-body">
              <mc-appointment-detail [appointment]="appointment"></mc-appointment-detail>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- LISTA HIPÓTESE DIAGNÓSTICA ******************************************** -->
    <div id="accordionDHF" class="mb-1">
        <div class="card">
          <div class="card-header">
            <strong>Hipótese diagnóstica</strong>
            <button class="btn btn-link float-right pt-0 pb-0 collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#collapseDHF"
              aria-expanded="true" aria-controls="collapseDHF">
              <fa-icon [icon]="eyeIcon"></fa-icon>
            </button>
          </div>
          <ul class="list-group list-group-flush collapse" id="collapseDHF" data-parent="#accordionDHF" *ngFor="let appointment of appointments">
            <li class="list-group-item d-flex" *ngIf="appointment.diagnostic_hypothesis">
              <span [innerHTML]="appointment.diagnostic_hypothesis"></span>
              <span class="badge badge-secondary ml-auto mb-auto" style="margin-top: -11px; margin-right: -19px;">{{appointment.date | date:'dd/LL/yyyy'}}</span>
            </li>
          </ul>
        </div>
    </div>

    <!-- LISTA PRESCRIÇÕES ******************************************************* -->
    <div id="accordionPrescriptions" *ngIf="prescriptions?.length > 0" class="mb-1">
        <div class="card">
          <div class="card-header">
            <strong>Prescrições</strong>
            <button class="btn btn-link float-right pt-0 pb-0 collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#collapsePrescriptions"
              aria-expanded="true" aria-controls="collapsePrescriptions">
              <fa-icon [icon]="eyeIcon"></fa-icon>
            </button>
          </div>
          <ul class="list-group list-group-flush collapse" id="collapsePrescriptions" data-parent="#accordionPrescriptions" *ngFor="let prescription of prescriptions">
            <li class="list-group-item d-flex">
              <span [innerHTML]="prescription.text"></span>
              <div class="ml-auto mb-auto" style="margin-top: -21px; margin-right: -19px;">
                <button (click)="printPrescription(prescription.id)" class="btn btn-link"><fa-icon [icon]="printIcon"></fa-icon></button>
                <span class="badge badge-secondary">{{prescription.date | date:'dd/LL/yyyy'}}</span>
              </div>
            </li>
          </ul>
        </div>
    </div>


    <!-- LISTA SOLICITAÇÕES ******************************************************* -->
    <div id="accordionRequests" *ngIf="exams?.length > 0" class="mb-1">
        <div class="card">
          <div class="card-header">
            <strong>Solicitações</strong>
            <button class="btn btn-link float-right pt-0 pb-0 collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#collapseRequests"
              aria-expanded="true" aria-controls="collapseRequests">
              <fa-icon [icon]="eyeIcon"></fa-icon>
            </button>
          </div>
          <ul class="list-group list-group-flush collapse"
              id="collapseRequests"
              data-parent="#accordionRequests"
              *ngFor="let examReq of exams">
            <div class="ml-auto mb-auto" style="margin-right: 1px; float: right;">
              <button (click)="printSadt(examReq.id)" class="btn btn-link"><fa-icon [icon]="printIcon"></fa-icon></button>
              <span class="badge badge-secondary">{{examReq.date | date:'dd/LL/yyyy'}}</span>
            </div>
            <span class="ml-3"><em>Indicação clínica:</em> {{examReq.root_cause}}</span>
            <li class="list-group-item">
              <span *ngFor="let exam of examReq.exam_templates; let i = index">
                {{i + 1}}. {{exam.name}} <br>
              </span>
            </li>
          </ul>
        </div>
    </div>


    <div class="d-flex mt-3">
      <button [hidden]="requesting || prescribing || editing" (click)="startRequesting()" class="btn btn-link ml-auto">
        <fa-icon [icon]="microscopeIcon" class="fa-3x mr-3"></fa-icon>
      </button>
      <button [hidden]="requesting || prescribing || editing" (click)="startPrescribing()" class="btn btn-link">
        <fa-icon [icon]="pillsIcon" class="fa-3x mr-3"></fa-icon>
      </button>
      <button [hidden]="requesting || prescribing || editing" (click)="startEditing()" class="btn btn-link">
        <fa-icon [hidden]="!editable" [icon]="editIcon" class="fa-3x"></fa-icon>
        <fa-icon [hidden]="editable" [icon]="plusCircle" class="fa-3x"></fa-icon>
      </button>
    </div>


    <mc-appointment-form *ngIf="editing" [appointment]="editableAppointment" (canceled)="onFormCanceled()" (saved)="onFormSaved($event)"></mc-appointment-form>
    <mc-prescription-form *ngIf="prescribing" (canceled)="onPrescribingCanceled()" (saved)="onPrescribingSaved($event)" [prescription]="prescription"></mc-prescription-form>
    <mc-exam-form *ngIf="requesting" [examRequest]="exam" (canceled)="onRequestingCanceled()" (saved)="onRequestingSaved($event)"></mc-exam-form>

    <br />
    <br />

</div>
